import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseService } from 'src/app/tabms/services/base/base.service';

@Component({
  selector: 'app-base-form-create-tools',
  templateUrl: './base-form-create-tools.component.html',
  styleUrl: './base-form-create-tools.component.scss'
})
export class BaseFormCreateToolsComponent {


  constructor(private baseService: BaseService) { }
  cancel() {
    this.clear();
    this.showHideCreateForm(false);
  }

  clear() {
    this.baseService.clearForm.next(true);
  }

  save() {
    this.baseService.saveForm.next(true);
    //this.cancel();
  }

  showHideCreateForm(isVisible) {
    this.baseService.createFormDisplay.next({ 'show': isVisible, 'id': null });
  }
}
